import { CustomWindow } from '../types/types'

const customWindow = typeof window !== 'undefined' ? window : null

export const wpSetUserConsent = (consent: boolean) => {
  if (customWindow as CustomWindow) {
    return (customWindow as CustomWindow).WonderPush.push([
      'setUserConsent',
      consent,
    ])
  }
}

export const wpGetUserConsent = () => {
  if (customWindow as CustomWindow) {
    return (customWindow as CustomWindow).WonderPush.getUserConsent()
  }
}

export const wpGetUserId = () => {
  if (customWindow as CustomWindow) {
    return (customWindow as CustomWindow).WonderPush.getUserId()
  }
}

export const wpSetUserId = (userId: string) => {
  if (customWindow as CustomWindow) {
    return (customWindow as CustomWindow).WonderPush.setUserId(userId)
  }
}

export const requestNotificationPermission = () => {
  if (typeof window !== 'undefined') {
    return window.Notification.requestPermission()
  }
}

export const wpSetSubscribeToNotifications = () => {
  if (customWindow as CustomWindow) {
    console.log('wpSetSubscribeToNotifications')
    return (customWindow as CustomWindow).WonderPush.push(function () {
      ;(customWindow as CustomWindow).WonderPush.subscribeToNotifications()
    })
    // return (customWindow as CustomWindow).WonderPush.subscribeToNotifications()
  }
}

export const wpSetUnsubscribeFromNotifications = () => {
  if (customWindow as CustomWindow) {
    console.log('wpSetUnsubscribeFromNotifications')
    return (customWindow as CustomWindow).WonderPush.push([
      'unsubscribeFromNotifications',
    ])
    // return (customWindow as CustomWindow).WonderPush.unsubscribeFromNotifications()
  }
}

export const wpCreateUserInteraction = () => {
  if (customWindow as CustomWindow) {
    return (customWindow as CustomWindow).WonderPush.push([
      'newUserInteraction',
    ])
    // return (customWindow as CustomWindow).WonderPush.newUserInteraction()
  }
}

export const wpRequestToFinalizeRegistration = () => {
  if (customWindow as CustomWindow) {
    return (customWindow as CustomWindow).WonderPush.push([
      'Notification.requestPopupToFinalizeRegistration',
    ])
    // return (customWindow as CustomWindow).WonderPush.Notification.requestPopupToFinalizeRegistration()
  }
}

export const wpNewPageLoaded = () => {
  if (customWindow as CustomWindow) {
    return (customWindow as CustomWindow).WonderPush.push(['newPageLoaded'])
    // return (customWindow as CustomWindow).WonderPush.newPageLoaded()
  }
}


export const wpIsUserSubscribedToNotifications = () => {
  if (customWindow as CustomWindow) {
    console.log('wpIsUserSubscribedToNotifications')
    return new Promise((resolve) => {
      ;(customWindow as CustomWindow).WonderPush.push(function () {
        ;(customWindow as CustomWindow).WonderPush.isSubscribedToNotifications().then(
          function (isSubscribed: boolean) {
            resolve(isSubscribed)
          }
        )
      })
    })
  }
  return new Promise((resolve) => resolve(false))
}

export const wpOnWonderPushEvent = (event: any, resolve: any) => {
  console.log('wpOnWonderPushEvent', event)
  if (!event.detail || event.detail.name !== 'subscription') return
  if (
    event.detail.state ===
    (customWindow as CustomWindow).WonderPush.SubscriptionState.SUBSCRIBED
  ) {
    resolve(true)
  }
}

export const wpListenToSubscribeEvent = () => {
  if (customWindow as CustomWindow) {
    console.log('wpListenToSubscribeEvent')
    return new Promise((resolve) => {
      window.addEventListener('WonderPushEvent', (event: any) =>
        wpOnWonderPushEvent(event, resolve)
      )
      wpIsUserSubscribedToNotifications().then((isSubscribed) => {
        if (isSubscribed) {
          resolve(true)
        }
      })
    })
  }
}

export const wpRemoveListenerToSubscribeEvent = () => {
  if (customWindow as CustomWindow) {
    console.log('wpRemoveListenerToSubscribeEvent')
    return new Promise((resolve) => {
      window.removeEventListener('WonderPushEvent', (event: any) =>
        wpOnWonderPushEvent(event, resolve)
      )
    })
  }
}

export const wpSendSelfNotification = () => {
  if (customWindow as CustomWindow) {
    console.log('wpSendSelfNotification')
    return (customWindow as CustomWindow).WonderPush.sendSelfNotification()
  }
}

export const wpVerifyUserIdSetup = async (
  expectedUserId: string,
  maxAttempts = 5
): Promise<boolean> => {
  if (!customWindow) return false

  let attempts = 0
  while (attempts < maxAttempts) {
    const currentWPUserId = await wpGetUserId()
    console.log(
      `[WonderPush] Verification attempt ${
        attempts + 1
      }: current userId=${currentWPUserId}, expected=${expectedUserId}`
    )

    if (currentWPUserId === expectedUserId) {
      return true
    }

    await new Promise((resolve) => setTimeout(resolve, 2000))
    attempts++
  }

  return false
}

export const wpEnsureProperSubscription = async (
  userId: string
): Promise<boolean> => {
  try {
    await wpSetUserConsent(true)
    const isSubscribed = await wpIsUserSubscribedToNotifications()
    if (!isSubscribed) {
      console.log(
        '[WonderPush] User not subscribed, initiating subscription process'
      )
      await wpSetSubscribeToNotifications()

      const subscriptionResult = await wpListenToSubscribeEvent()
      if (!subscriptionResult) {
        console.log('[WonderPush] Subscription failed')
        return false
      }
    }

    console.log('[WonderPush] Setting user ID:', userId)
    await wpSetUserId(userId)

    const verified = await wpVerifyUserIdSetup(userId)
    if (!verified) {
      console.log('[WonderPush] Failed to verify user ID setup')
      return false
    }

    console.log('[WonderPush] Subscription process completed successfully')
    return true
  } catch (error) {
    console.error('[WonderPush] Error in subscription process:', error)
    return false
  }
}

export const wpGetInstallationId = () => {
  if (customWindow as CustomWindow) {
    return (customWindow as CustomWindow).WonderPush.getInstallationId()
  }
}

export const wpCheckAndFixInstallation = async (
  userId: string
): Promise<boolean> => {
  try {
    console.log('[WonderPush] Checking installation...')
    
    const notificationPermission = typeof Notification !== 'undefined' ? Notification.permission : 'default'
    console.log('[WonderPush] Browser notification permission:', notificationPermission)
    
    if (notificationPermission === 'denied') {
      console.log('[WonderPush] Browser notifications are blocked by user')
      return false
    }

    const currentUserId = await wpGetUserId()

    console.log('[WonderPush] Checking installation:', {
      currentUserId,
      expectedUserId: userId,
      notificationPermission,
    })

    if ((!currentUserId || currentUserId !== userId)) {
      console.log(
        '[WonderPush] Found installation without proper userId, fixing...'
      )
      await wpSetUserId(userId)
      return await wpVerifyUserIdSetup(userId)
    }

    console.log('[WonderPush] Installation is correct')

    return true
  } catch (error) {
    console.error('[WonderPush] Error checking installation:', error)
    return false
  }
}
